import React from "react";
import { Helmet } from "react-helmet-async";
import { Box, Select, MenuItem, Typography } from "@mui/material";

import SecRuleTable from "./component/T_SecRule";
import EditCrsSecRuleModal from "./component/M_EditCrsSecRule";

import useRule from "../../../hooks/super/useRule";
import useAuth from "../../../hooks/useAuth";

import { CollapseAlert, IOSSwitch } from "../../../components/pages/common/styled";
import { UserType } from "../../../utils/constants";
import PageHeader from "../../../components/pages/_new/super/common/PageHeader";
import { TOKENS, SectionCard } from "../../../components/pages/_new/super/design";

function SASdRule() {
  const { isAuthenticated, adminUserType } = useAuth();
  const {
    getSdSigRules,
    curruleEnableChange,
    selectCurrentRule,
    sdSigRules,
    currule,
    errMsg,
    setErr,
  } = useRule();

  React.useEffect(() => {
    window.scrollTo(0, 0);
    if (isAuthenticated) getSdSigRules();
    setErr(null);
    return () => setErr(null);
  }, [isAuthenticated, setErr, getSdSigRules]);

  const [ruleID, setRuleID] = React.useState();
  const [currule_enable, set_currule_enable] = React.useState();

  React.useEffect(() => {
    if (sdSigRules === null) return;
    if (sdSigRules?.length === 0) return;
    setRuleID(sdSigRules[0]?.rule_id);
  }, [sdSigRules]);

  React.useEffect(() => {
    if (!isAuthenticated) return;
    if (ruleID === null || ruleID === undefined) return;
    selectCurrentRule(ruleID);
  }, [isAuthenticated, ruleID, selectCurrentRule]);
  React.useEffect(() => {
    if (currule === null || currule === undefined) return;
    set_currule_enable(currule?.enabled);
  }, [currule]);
  const selectRuleCategory = (event) => setRuleID(event.target.value);

  const [open, setOpen] = React.useState(false);

  const crsRuleChange = () => {
    curruleEnableChange({
      rule_id: currule.rule_id,
      enable: !currule_enable,
    });
    set_currule_enable(!currule_enable);
  };

  const [errOpen, setErrOpen] = React.useState(false);
  React.useEffect(() => {
    setErrOpen(true);
  }, [errMsg]);

  const canEdit = [UserType.SUPER_ADMIN, UserType.ADMIN].includes(adminUserType);

  return (
    <React.Fragment>
      <Helmet title="SA Layerd AI Signature Rule Management" />
      <PageHeader
        title="Layerd AI Signature Rules"
        description="Configure Layerd AI signature rule categories and enable/disable individual SecRules"
      />
      <Box sx={{ mb: 3 }}>
        <CollapseAlert errOpen={errOpen} setErrOpen={setErrOpen} setErr={setErr} errMsg={errMsg} />
      </Box>

      <Box sx={{ display: "grid", gap: 2 }}>
        <SectionCard
          title="Category"
          description="Pick a Layerd AI signature rule category to view and toggle individual SecRules."
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
            <Select
              value={ruleID !== undefined ? ruleID : ""}
              onChange={selectRuleCategory}
              size="small"
              sx={{
                minWidth: 360,
                borderRadius: `${TOKENS.radiusXs}px`,
                background: TOKENS.bgSurface,
              }}
            >
              {sdSigRules?.map((rule, i) => (
                <MenuItem key={i} value={rule.rule_id}>
                  {rule.description || rule.name}
                </MenuItem>
              ))}
            </Select>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                border: `1px solid ${TOKENS.border}`,
                borderRadius: `${TOKENS.radiusXs}px`,
                px: 1.5,
                py: "6px",
                background: TOKENS.bgSurface,
              }}
            >
              <Typography sx={{ fontSize: 13, color: TOKENS.fg1 }}>
                Category enabled
              </Typography>
              <IOSSwitch
                checked={!!currule_enable}
                onChange={crsRuleChange}
                disabled={!canEdit}
              />
            </Box>
          </Box>
        </SectionCard>

        <SectionCard title="Rules in this category">
          <SecRuleTable disable={!currule_enable} />
        </SectionCard>
      </Box>

      <EditCrsSecRuleModal open={open} handleClose={() => setOpen(false)} />
    </React.Fragment>
  );
}

export default SASdRule;
